


















import { Component, Vue } from 'vue-property-decorator';

import { AppModule } from '@/store/modules/app';
import GlobalProgress from '@/components/global/Progress/index.vue';
import AppNavbarSidebarToggle from './AppNavbarSidebarToggle.vue';
import AppNavbarBreadcrumbs from './AppNavbarBreadcrumbs.vue';
import AppNavbarMenu from './AppNavbarMenu.vue';
import AppNavbarMobileMenu from './AppNavbarMobileMenu.vue';

@Component({
  name: 'AppNavbar',
  components: {
    GlobalProgress,
    AppNavbarSidebarToggle,
    AppNavbarBreadcrumbs,
    AppNavbarMenu,
    AppNavbarMobileMenu,
  },
})
export default class extends Vue {
  get isMobile() {
    return this.$vuetify.breakpoint.smAndDown;
  }

  get isSidebarOpen() {
    return AppModule.sidebar.opened;
  }

  get sidebarToggleEvent() {
    return AppNavbarSidebarToggle.sidebarToggleEvent;
  }

  private toggleSidebar() {
    AppModule.ToggleSideBar();
  }
}
